import classnames from 'classnames';
import * as React from 'react';
import { observer } from 'mobx-react';

import { ccNumberFormatter, ccExpFormatter } from '../../cc-formatters';
import { MatField } from 'src/core/components/mat-field';

import styles from './card-info.less';
import { CardInfoFormState } from '../card-info';

interface Props {
    data: CardInfoFormState;
    isAnonymousPayments: boolean;
}

export const CardInfo = observer<React.SFC<Props>>(
    ({ data, isAnonymousPayments }) => (
        <>
            <div>
                <div className={classnames('row', styles.row, styles.firstRow)}>
                    <div className={classnames('col', styles.col)}>
                        <MatField
                            fullWidth
                            errorColor
                            fieldState={data.ccName}
                            maxLength={26}
                            autoComplete="cc-name"
                            label="Name on card"
                        />
                    </div>
                    <div className={classnames('col', styles.col)}>
                        <MatField
                            fullWidth
                            errorColor
                            fieldState={data.ccNumber}
                            maxLength={22}
                            autoComplete="cc-number"
                            label="Card number"
                            inputRef={(ref) => ccNumberFormatter(ref)}
                        />
                    </div>
                </div>

                <div className={classnames('row', styles.row, styles.secondRow)}>
                    <div className={classnames('col', styles.col)}>
                        <MatField
                            fullWidth
                            errorColor
                            fieldState={data.ccExp}
                            maxLength={5}
                            autoComplete="cc-exp"
                            label="MM / YY"
                            inputRef={(ref) => ccExpFormatter(ref)}
                        />
                    </div>
                    <div className={classnames('col', styles.col)}>
                        <MatField
                            fullWidth
                            errorColor
                            fieldState={data.ccCsc}
                            maxLength={4}
                            autoComplete="cc-csc"
                            label="Security code"
                        />
                    </div>
                    <div className={classnames('col', styles.col)}>
                        <div className="full-width">
                            <MatField
                                fullWidth
                                errorColor
                                fieldState={data.postalCode}
                                maxLength={10}
                                autoComplete="postal-code"
                                label="Postal Code"
                            />
                        </div>
                    </div>
                </div>
            </div>

            {isAnonymousPayments && (
                <div className={classnames('card', styles.card, styles.agreement)}>
                    <p className="gray-text">
                        I agree to pay the above amount in accordance with my cardholder agreement.
                        By clicking “Submit Payment,” you confirm that you accept the{' '}
                        <a
                            target="_blank"
                            href="https://www.servicetitan.com/terms-of-use"
                            rel="noreferrer"
                        >
                            Terms of Service
                        </a>{' '}
                        &amp;{' '}
                        <a
                            target="_blank"
                            href="https://www.servicetitan.com/privacy-policy"
                            rel="noreferrer"
                        >
                            Privacy Policy
                        </a>
                        .
                    </p>
                </div>
            )}
        </>
    )
);
